module.exports = __webpack_public_path__ + "img/bench_259.0bb34052.jpg";